import React from "react";
import { FormatMoney } from "../../../utils/formatMoney";

const TenorOver = ({ salary }) => {
  return (
    <div className="my-12">
    <h2 className=" uppercase letter-spacing font-semibold text-gray-800 mt-5">
      Salary Analysis Summary{" "}
    </h2>
    <hr />
    <div className="mt-8 flex flex-col">
      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
      { salary ? salary?.map((item, index) => {
        const transaction_1 =
          item?.firstHalfMonthSalaryBreakdown?.transactions[0];
        const transaction_2 =
          item?.secondHalfMonthSalaryBreakdown?.transactions[0];
        const transactionDate1 = transaction_1?.transactionDate ? new Date(
          transaction_1?.transactionDate
        ).toLocaleDateString("en-US", { month: "long", year: "numeric" }) : "Empty";
        const transactionDate2 = transaction_2?.transactionDate ? new Date(
          transaction_2?.transactionDate
        ).toLocaleDateString("en-US", { month: "long", year: "numeric" }) : "Empty";

        return (
          <div className="border-b ">
            <div>
            {
                transactionDate1 ? (<div className="mt-7">
                    <h1 className="ml-3 font-semibold text-lg mb-6">{transactionDate2}</h1>
                <h1 className="ml-3 font-semibold">First Half Month Salary Breakdown</h1>
                <table className=" min-w-full table-fixed divide-y divide-gray-300" border="1" cellPadding="10">
              <thead>
                <tr>
                  <th  scope="col"
                    className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800">Transaction Date</th>
                 
                  <th  scope="col"
                    className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800">Value Date</th>
                  <th  scope="col"
                    className="min-w-[8rem] px-3 py-3.5 text-left italic font-normal text-gray-800 ">Narration</th>
                  <th  scope="col"
                    className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800">Amount</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">  
              <tr className="bg-gray-50" key={index}>
                <td>
                {transaction_1?.transactionDate ? new Date(
                    transaction_1?.transactionDate
                ).toLocaleDateString() : " Empty"}
                </td>
                
                <td>
                { transaction_1?.valueDate ? new Date(
                    transaction_1?.valueDate
                ).toLocaleDateString() : " Empty"}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-gray-900">{transaction_1?.naration ?? "Empty"}</td>
                <td className="whitespace-nowrap px-3 py-4 text-gray-900">{FormatMoney(transaction_1?.amount) ?? "Empty"}</td>
                </tr>
              </tbody>
                </table>
                </div>) : ""
            }
            {
                transactionDate2 ? (<div className="mt-10">
                <h1 className="ml-3 font-semibold">Secondary Half Month Salary Breakdown</h1>
                <table className="min-w-full table-fixed divide-y divide-gray-300" border="1" cellPadding="10">
              <thead>
                <tr>
                  <th  scope="col"
                    className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800">Transaction Date</th>
           
                  <th  scope="col"
                    className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800">Value Date</th>
                  <th  scope="col"
                    className="min-w-[8rem] px-3 py-3.5 text-left italic font-normal text-gray-800 ">Narration</th>
                  <th  scope="col"
                    className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800">Amount</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">  
              <tr className="bg-gray-50" key={index}>
                <td>
                {new Date(
                    transaction_2?.transactionDate
                ).toLocaleDateString()}
                </td>
              
                <td>
                {new Date(
                    transaction_2?.valueDate
                ).toLocaleDateString()}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-gray-900">{transaction_2?.naration}</td>
                <td className="whitespace-nowrap px-3 py-4 text-gray-900">{FormatMoney(transaction_2?.amount)}</td>
                </tr>
              </tbody>
            </table>
                </div>) : ""
            }
          </div>
           <div className=" flex items-center gap-5 mt-4 mb-4 ml-2 bg-slate-800 text-white font-semibold px-3 py-2 w-[90%]">
           <h3 className=" ">Selected Amount</h3>
           <p className="">{FormatMoney(item?.selectedSalaryAmount)}</p>
         </div>
          </div>
        );
      }) : <>
        <h1>Nothing to show</h1>
      </>}
     </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default TenorOver;
